module.exports = __webpack_public_path__ + "assets/img/pt-e9c66e71.png";